export default class PrivacySettings {
  constructor() {
    const cookieBanner = document.querySelector("cookie-banner")
    const settingsButton = document.getElementById("privacy-settings")

    if (settingsButton && cookieBanner) {
      settingsButton.addEventListener("click", () => {
        cookieBanner.promptForConsent()
      })
    }
  }
}
